import { ofType } from 'redux-observable';
import { catchError, concatMap, switchMap, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';

import { getHotelSearchResults$ } from 'api/tretail/hotel';
import validateHotelSearchResultsResponse from 'api/tretail/hotel/validateHotelSearchResultsResponse';
import { getOffersTermsAndConditionsContent$ } from 'api/content';
import { fetchOffersTermsAndConditionsContentFulfilled } from 'store/offersTermsAndConditionsContent';
import {
	fetchSearchResultsForResultSetId,
	fetchSearchResultsForResultSetIdFulfilled,
	fetchSearchResultsFailed,
	fetchSearchResultsCancel,
} from '../searchResults.slice';
import buildFetchSearchResultsFailedPayload from '../buildFetchSearchResultsFailedPayload';
import getOfferCodesFromHotelResultsResponse from '../getOfferCodesFromHotelResultsResponse';

export default function fetchSearchResultsForResultSetIdEpic(action$) {
	return action$.pipe(
		ofType(fetchSearchResultsForResultSetId.type),
		switchMap(({ payload: { locale, resultSetId, searchParams } }) =>
			getHotelSearchResults$({
				locale,
				resultSetId,
			}).pipe(
				switchMap(getHotelSearchResultsResponse => {
					validateHotelSearchResultsResponse(getHotelSearchResultsResponse);

					const roomTypeIds = getOfferCodesFromHotelResultsResponse(getHotelSearchResultsResponse);
					return getOffersTermsAndConditionsContent$({
						locale,
						hotelCode: searchParams.hotelCode,
						checkinDate: searchParams.dates.checkIn,
						checkoutDate: searchParams.dates.checkOut,
						promoCode: searchParams.promoCode,
						roomTypeIds,
					}).pipe(
						catchError(() => of([])),
						concatMap(offersTermsAndConditionsContent => [
							fetchSearchResultsForResultSetIdFulfilled({
								data: getHotelSearchResultsResponse,
							}),
							fetchOffersTermsAndConditionsContentFulfilled(offersTermsAndConditionsContent),
						])
					);
				}),
				catchError(error =>
					of(
						fetchSearchResultsFailed(
							buildFetchSearchResultsFailedPayload(error, { resultSetId })
						)
					)
				),
				takeUntil(action$.pipe(ofType(fetchSearchResultsCancel.type)))
			)
		)
	);
}
